module.exports = __webpack_public_path__ + "img/export.00109668.svg";